import React from 'react'
import Sidebar from '../Component/Sidebar'
import Dashboard from '../Component/Dashboard'
function Index() {
  return (
    <div className='index-box'>
        <Sidebar />
       <Dashboard />   
        
      
    </div>
  )
}

export default Index
